import React, { useState, useEffect } from "react";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import { SERVER_APIS } from "../../constants";
import Breadcrumb from "../../components/breadcrumb/breadcrumb";

const SiteMap = () => {
  const [data, setData] = useState({
    iopCenterResult: [],
    residentialResult: [],
    phpResult: [],
    detoxResult: [],
    topStateData: {},
    men: [],
    women: [],
    lgbtq: [],
    recommendedUrl: [],
    posts: [],
    pages: [],
    resources: [],
  });

  const [timeoutReached, setTimeoutReached] = useState(false);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      window.scrollTo(0, 0);
    }
  }, [data]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setTimeoutReached(true);
    }, 60000);

    const fetchSiteMapData = async () => {
      const siteMapTitlePromise = axios.get(SERVER_APIS.SiteMapTitle);
      const siteMapPromise = axios.get(SERVER_APIS.SiteMap);

      siteMapTitlePromise
        .then((res) => {
          const {
            iopCenterResult,
            residentialResult,
            phpResult,
            detoxResult,
            topStateData,
            men,
            women,
            lgbtq,
            recommendedUrl,
          } = res.data;

          setData((prev) => ({
            ...prev,
            iopCenterResult,
            residentialResult,
            phpResult,
            detoxResult,
            topStateData,
            men,
            women,
            lgbtq,
            recommendedUrl,
          }));
        })
        .catch((err) => console.error("Error in SiteMapTitle:", err));

      siteMapPromise
        .then((res) => {
          const { postsResponse, pagesResponse, resourceResponse } = res.data;

          setData((prev) => ({
            ...prev,
            posts: postsResponse,
            pages: pagesResponse,
            resources: resourceResponse,
          }));
        })
        .catch((err) => console.error("Error in SiteMap:", err));

      // Optional: clear timeout when both are done
      Promise.allSettled([siteMapTitlePromise, siteMapPromise]).then(() => {
        clearTimeout(timeout);
      });
    };

    fetchSiteMapData();

    return () => clearTimeout(timeout);
  }, []);

  const renderUrlList = (items, type) => {
    const isEmpty = !items || items.length === 0;

    if (isEmpty && timeoutReached) {
      return (
        <ul
          className="list-style-disc"
          style={{ padding: "0", paddingLeft: "20px" }}
        >
          <li>
            Hmm, looks like we couldn't fetch the data. Try refreshing or check
            back soon!
          </li>
        </ul>
      );
    }

    if (isEmpty) {
      return (
        <ul
          className="list-style-disc"
          style={{ padding: "0", paddingLeft: "20px" }}
        >
          <li>
            <Skeleton height={20} />
          </li>
          <li>
            <Skeleton height={20} />
          </li>
          <li>
            <Skeleton height={20} />
          </li>
        </ul>
      );
    }

    return (
      <ul
        className="list-style-disc"
        style={{ padding: "0", paddingLeft: "20px" }}
      >
        {items.map((item, index) => (
          <li key={item.id || item.link || index}>
            <a
              href={item.link || item.livingNameUrl || "#"}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "#007BFF" }}
            >
              {type === "posts" || type === "pages" || type === "resources"
                ? item.title?.rendered
                : item.name}
            </a>
          </li>
        ))}
      </ul>
    );
  };
  const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "Site Map", path: "/site-map" },
  ];

  return (
    <>
      <Breadcrumb items={breadcrumbItems} />
      <section className="container has-breadcrumb savehome-wrp setting-list pb-5 pb-lg-0">
        <h1 className="main-title title-decoration">Site Map</h1>
        <ul
          className="list-style-disc"
          style={{ padding: "0", paddingLeft: "20px" }}
        >
          <li className="listing-header site-map-header mb-3 pt-3">
            <h3>Detox Centers</h3>
            {renderUrlList(data.detoxResult)}
          </li>

          <li className="listing-header site-map-header mb-3 pt-3">
            <h3>Residential Centers</h3>
            {renderUrlList(data.residentialResult)}
          </li>

          <li className="listing-header site-map-header mb-3 pt-3">
            <h3>PHP Centers</h3>
            {renderUrlList(data.phpResult)}
          </li>

          <li className="listing-header site-map-header mb-3 pt-3">
            <h3>IOP Centers</h3>
            {renderUrlList(data.iopCenterResult)}
          </li>

          <li className="listing-header site-map-header mb-3 pt-3">
            <h3>Sober Living</h3>
            <div style={{ paddingLeft: "20px" }}>
              <ul
                className="list-style-disc"
                style={{ padding: "0", paddingLeft: "0px" }}
              >
                {Object.keys(data.topStateData).map((state) => {
                  if (
                    !data.topStateData[state] ||
                    data.topStateData[state].length === 0
                  ) {
                    return null;
                  }

                  return (
                    <li
                      key={state}
                      style={{ marginBottom: "20px" }}
                      className="site-map-sub-header"
                    >
                      <h3
                        style={{
                          fontSize: "20px",
                          fontWeight: "600",
                          color: "#444",
                          marginBottom: "10px",
                        }}
                      >
                        {state}
                      </h3>
                      {renderUrlList(data.topStateData[state])}
                    </li>
                  );
                })}
              </ul>

              <li className="listing-header site-map-header mb-3 pt-3">
                <h3
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "15px",
                  }}
                >
                  Men
                </h3>
                {renderUrlList(data.men)}
              </li>

              <li className="listing-header site-map-header mb-3 pt-3">
                <h3
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "15px",
                  }}
                >
                  Women
                </h3>
                {renderUrlList(data.women)}
              </li>

              <li className="listing-header site-map-header mb-3 pt-3">
                <h3
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "15px",
                  }}
                >
                  LGBTQ Centers
                </h3>
                {renderUrlList(data.lgbtq)}
              </li>

              <li className="listing-header site-map-header mb-3 pt-3">
                <h3
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "15px",
                  }}
                >
                  Recommended URLs
                </h3>
                {renderUrlList(data.recommendedUrl)}
              </li>
            </div>
          </li>

          <li className="listing-header site-map-header mb-3 pt-3">
            <h3>Posts</h3>
            {renderUrlList(data.posts, "posts")}
          </li>

          <li className="listing-header site-map-header mb-3 pt-3">
            <h3>Pages</h3>
            {renderUrlList(data.pages, "pages")}
          </li>

          <li className="listing-header site-map-header mb-3 pt-3">
            <h3>Recovery Resources</h3>
            {renderUrlList(data.resources, "resources")}
          </li>

          <li
            className="listing-header site-map-header mb-3 pt-3"
            style={{ marginBottom: "30px" }}
          >
            <h3>Helpful Resources</h3>
            <ul
              className="list-style-disc"
              style={{ padding: "0", paddingLeft: "20px" }}
            >
              <li>
                <a
                  href="https://www.tasterecovery.com/about-us"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    color: "#007BFF",
                  }}
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="https://www.tasterecovery.com/terms-of-service"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    color: "#007BFF",
                  }}
                >
                  Terms and Conditions
                </a>
              </li>

              <li>
                <a
                  href="https://www.tasterecovery.com/help-and-support"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    color: "#007BFF",
                  }}
                >
                  Help and Support
                </a>
              </li>

              <li>
                <a
                  href="https://www.tasterecovery.com/resources/blog"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    color: "#007BFF",
                  }}
                >
                  Resources Blog
                </a>
              </li>

              <li>
                <a
                  href="https://www.tasterecovery.com/resources/recovery-resources"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    color: "#007BFF",
                  }}
                >
                  Recovery Resources
                </a>
              </li>

              <li>
                <a
                  href="https://www.tasterecovery.com/contact-support"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    color: "#007BFF",
                  }}
                >
                  Contact Support
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </section>
    </>
  );
};

export default SiteMap;
